import { FindingsAlert, FindingsSelector } from '@app/icare/components/findings'
import { PatientRelativeEditDrawer } from '@app/icare/entities/patient/edits/PatientRelativeEditDrawer'
import { selectByGroup } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { patientQueryOptions } from '@app/icare/entities/patient/queries/patientQueryOptions'
import type { PatientWithRelations } from '@app/icare/entities/patient/schema/Patient'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { isActivePatientRelation, sortByActiveRange } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { formatAddress, formatDate } from '@pkg/shared/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button, Flex, Table } from 'antd'
import { FaPencil } from 'react-icons/fa6'

export const Route = createFileRoute('/_app/patienten/$id/_edit/stammdaten/angehoerige')({
  component: RouteComponent,
  params: entityParams({ id: PatientId }),
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()
  const { data } = useSuspenseQuery(patientQueryOptions(patientId))
  const patient = data as PatientWithRelations

  const relatives = (patient.relatives ?? []).filter(isActivePatientRelation).sort(sortByActiveRange)

  return (
    <Flex vertical gap="small">
      <FindingsSelector selector={selectByGroup('relatives')}>{f => <FindingsAlert findings={f} />}</FindingsSelector>

      <Table
        dataSource={relatives}
        rowKey="id"
        size="small"
        pagination={false}
        locale={{ emptyText: t`Keine Angehörigen vorhanden` }}
        columns={[
          {
            title: t`Name`,
            render: (_, r) => formatAddress([r.firstName, r.lastName], undefined),
          },
          {
            title: t`Adresse`,
            render: (_, r) => formatAddress([], r.address),
          },
          {
            title: t`Telefon`,
            dataIndex: ['contact', 'phone'],
          },
          {
            title: t`Mobil`,
            dataIndex: ['contact', 'mobile'],
          },
          {
            title: t`Gültig ab`,
            render: (_, r) => formatDate(r.activeFrom),
          },
          {
            title: t`Gültig bis`,
            render: (_, r) => formatDate(r.activeTo),
          },
          {
            key: 'actions',
            width: 80,
            render: (_, r) => (
              <Button
                aria-label={t`${r.firstName} ${r.lastName} bearbeiten`}
                type="text"
                size="small"
                icon={<FaPencil />}
                onClick={() => PatientRelativeEditDrawer.show({ patientId, relationId: r.id })}
              />
            ),
          },
        ]}
      />
    </Flex>
  )
}
